// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/css/appearance.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/css/customer.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/css/header.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/css/mediapopup.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/CyGrotesk-KeyRegular.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/images/checkbox-black.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/images/down-arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-green: #55883D;
  --white: #ffffff;
  --black: #000000;
  --cloudburst: #344054;
  --ashyblue: #d0d5dd;
  --lightgrey: #eaecf0;
  --grey: #667085;
  --grayishblue: #475467;
  --whitesmoke: #f9f9f9;
  --lightgrey: #eaecf0;
  --frostedwhite: #fbfbfb;
  --charcoalblue: #0a2540;
  --fiord: #425466;
  --purple: #573cff;
  --mistygray: #f2f4f7;
  --ghostwhite: #f9fafb;
  --grayishblue: #475467;
  --greenlable: #067647;
  --greenlableborder: #079455;
  --twilightblue: #363F72;
  --twilightblueborder: #3E4784;
  --boxshadow: 0 1px 3px #0000001a;
  --eerieblack: #1c1c1c;
  --darkblue: #101828;
  --frostedwhite: #fbfbfb;
  --vibrantblue: #007aff;
  --tooltipboxshadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);
}

ul,
li {
  list-style-type: none;
}

* {
  box-sizing: border-box;
}

body,
html {
  overflow-x: hidden;
  position: relative;
}

body {
  background: white;
}

body {
  margin: 0;
  /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@font-face {
  font-family: 'CyGrotesk-KeyRegular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
}

input[type="checkbox"] {
  cursor: pointer;
}

input[type="checkbox"]:checked:before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  border: 1px solid #344054;
}

input[type=number] {
  -moz-appearance: textfield;
  /* Firefox */
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  /* Chrome, Safari, Edge */
  margin: 0;
}

input[type="checkbox"]:before {
  content: "";
  font-size: 15px;
  border: 1px solid #d0d5dd;
  display: block;
  width: 15px;
  background: none;
  height: 15px;
  margin-right: 7px;
  border-radius: 4px;
  min-width: 16px;
  min-height: 16px;
  margin-right: 15px;
  background-size: 60%;
  background-position: 4px center;
  background-repeat: no-repeat;
  accent-color: #e6f2ff;
}

.pagesTable {
  background: #fff;
  border: 1px solid #eaecf0;
  width: 100%;
  margin-top: 20px;
  border-radius: 6px;
  position: relative;
}

.dataTable-list .rdt_TableBody .rdt_TableRow {
  min-height: 62px;
}

.dataTable-list .rdt_TableHeadRow .rdt_TableCol:first-child,
.dataTable-list .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child {
  padding-left: 16px;
}

.dataTable-list .rdt_TableHeadRow .rdt_TableCol input:first-child {
  margin-right: 0;
}

.dataTable-list .rdt_TableHeadRow .rdt_TableCol:last-child,
.dataTable-list .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child {
  justify-content: flex-end;
  padding-right: 16px;
}

.dataTable-list .rdt_TableHeadRow .rdt_TableCol .__rdt_custom_sort_icon__ {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  width: 12px;
  height: 12px;
  margin-left: 5px;
  background-repeat: no-repeat;
  background-position: center;
}

.dataTable-list .rdt_TableHeadRow .rdt_TableCol .desc.__rdt_custom_sort_icon__ {
  transform: rotate(180deg);
}

.dataTable-list {
  background: #ffffff;
  border: 1px solid #eaecf0;
  width: 100%;
  margin-top: 20px;
  border-radius: 6px;
  position: relative;
}

.dataTable-list input[type="checkbox"]:before {
  margin-right: 10px;
}

.dataTable-list .rdt_TableHeadRow .rdt_TableCol {
  padding: 0;
  padding-top: 20px;
  padding-bottom: 20px;
  justify-content: flex-start;
}

.dataTable-list .rdt_TableHeadRow div[data-column-id] {
  font-weight: 500;
  color: #4e575c;
  font-size: 14px;
}

.dataTable-list>div:first-child {
  padding-bottom: 80px;
  margin-bottom: -80px;
}

.dataTable-list>div:last-child {
  position: relative;
}

.dataTable-list .user-status a.user-link,
.user-status {
  align-items: center;
  display: flex;
  gap: 12px;
}

.dataTable-list .rdt_TableHeadRow .rdt_TableCol:last-child,
.dataTable-list .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child {
  justify-content: flex-end;
  padding-right: 16px;
}

.dataTable-list .table-action {
  padding-right: 0;
}

.table-action img {
  cursor: pointer;
}

.table-data-dropdown {
  padding: 0 !important;
  background: #fff;
  border: 1px solid #eaecf0;
  border-radius: 6px;
  box-shadow: 0 12px 16px -4px rgba(16, 24, 40, .08), 0 4px 6px -2px rgba(16, 24, 40, .03);
  min-width: 160px;
  position: absolute;
  right: auto;
  top: 50px;
  z-index: 99;
}

.table-data-dropdown.is-open {
  padding: 0 !important;
  background: #fff;
  border: 1px solid #eaecf0;
  border-radius: 6px;
  box-shadow: 0 12px 16px -4px rgba(16, 24, 40, .08), 0 4px 6px -2px rgba(16, 24, 40, .03);
  min-width: 160px;
  position: absolute;
  right: auto;
  top: -115px;
  z-index: 99;
}

.table-data-dropdown ul {
  padding: 0;
  margin: 0;
}

.table-data-dropdown li span {
  align-items: center;
  color: #111827;
  display: flex;
  justify-content: flex-start;
  padding: 0px 20px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  cursor: pointer;
}

.table-data-dropdown li span:hover {
  background: #f9f9f9;
  color: #101828;
}

.table-data-dropdown li span img {
  margin-right: 10px;
}

input[type="checkbox"] {
  -moz-appearance: none;
  -webkit-appearance: none;
  -o-appearance: none;
  background: #fff;
  border: none !important;
  content: none;
  cursor: pointer;
  outline: none;
  cursor: pointer;
}

.error-message {
  font-size: 14px;
  color: #d92d20;
  margin-top: 5px;
  margin-bottom: 0;
}

.error-border {
  border-color: #d92d20 !important;
}

.editor-error {
  max-width: 740px;
  margin: auto;
  padding: 0 20px;
}

.dataTable-border-list .sc-dYwGCk:last-child,
.dataTable-border-list .sc-bRKDuR {
  border-radius: 0 0 6px 6px;
}

.editTitle a {
  color: #000;
}

.category-list .dropdown-list {
  max-height: 150px;
}

.dropdown-list {
  position: absolute;
  top: 45px;
  left: 0;
  width: 100%;
  background: #fff;
  border-radius: 6px;
  border: 1px solid #d0d5dd;
  padding: 10px 12px;
  /* box-shadow: 0px 4px 10px rgba(0,0,0,0.15); */
  z-index: 9;
  max-height: 260px;
  overflow-y: auto;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
  cursor: pointer;
}

.dropdown-item.customer-list-dropdown {
  gap: 2px;
}

.dropdown-item.customer-list-dropdown span:last-child {
  font-size: 14px;
}

.dropdown-item input {
  width: 18px;
  height: 18px;
}

.dropdown-wrapper.order-dropdown,
.dropdown-wrapper.review-dropdown {
  width: 100%;
}

.dropdown-wrapper.review-dropdown {
  margin-top: 10px;
}

.dropdown-wrapper {
  width: 240px;
  position: relative;
}

.brand-dropdown {
  margin-top: 10px;
}

.dropdown-wrapper.send-mail-dropdown,
.dropdown-wrapper.brand-dropdown,
.dropdown-wrapper.refund-reason-dropdown {
  width: 100%;
}

.send-mail-dropdown .dropdown-list,
.brand-dropdown .dropdown-list,
.refund-reason-dropdown .dropdown-list {
  margin-top: 5px;
  max-height: 200px;
}

.category-list,
.parent-category-list-dropdown {
  width: 100%;
}

.dropdown-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: #fff;
  border: 1px solid #d0d5dd;
  border-radius: 6px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  /* box-shadow: 0px 2px 4px rgba(0,0,0,0.08); */
  height: 40px;
}

.dropdown-header .header-title {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  line-height: 1.1;
}

.popup-box.add-refund {
  overflow-y: unset;
}

.add-refund .dropdown-wrapper {
  width: 100%;
}

.add-refund .dropdown-header {
  justify-content: space-between;
}

.dropdown-header.customer-list-header>div {
  width: calc(100% - 30px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.customer-list-header span {
  font-size: 14px;
}

.dropdown-header .title {
  font-weight: 500;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  line-height: 1.1;
}

.category-list .dropdown-header,
.parent-category-list-dropdown {
  margin-top: 10px;
}

.category-list .title {
  color: var(--grey);
  font-size: 14px;
}

.category-list .dropdown-item span {
  font-size: 14px;
}

.arrow {
  margin-left: auto;
  transition: 0.25s;
  opacity: 0.6;
  margin-top: -4px;
}

.arrow.rotate {
  transform: rotate(180deg);
  margin-top: 4px;
}

.product-list .dropdown-wrapper {
  width: 220px;
}

.upload-btn {
  background: #55883b;
  padding: 8px 14px;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  display: inline-block;
}

.image-preview {
  margin-top: 10px;
}

.preview-img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #ddd;
}


.image-upload-content {
  display: flex;
  gap: 15px;
  font-size: 14px;
  cursor: pointer;
}

.popupModalTitle {
  margin-top: 10px;
  color: #101828;
  font-size: 18px;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 15px;
  margin-top: 0;
  padding: 0;
}

.popupDesc {
  font-size: 14px;
  font-weight: 400;
  color: var(--grayishblue);
  line-height: 20px;
  display: block;
  margin-bottom: 5px;
}

.popup-overlay {
  background-color: rgba(0, 0, 0, .5);
  opacity: 1;
  position: fixed;
  visibility: visible;
  z-index: 31;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}

.popup-box {
  max-height: max-content;
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #d0d5dd;
  box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03),
    0px 20px 24px -4px rgba(16, 24, 40, 0.08);
  border-radius: 6px;
  left: 50%;
  max-width: 480px;
  opacity: 1;
  padding: 25px;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  visibility: visible;
  width: 100%;
  z-index: 35;
  height: 100%;
  margin: 0 20px 0;
}

.popup-form .form-group {
  margin-bottom: 12px;
}

.popup-form .form-checkbox {
  display: flex;
  align-items: center;
  gap: 5px;
}

.popup-form .form-checkbox input {
  width: 20px;
}

.role-dropdown-list {
  margin-top: 12px;
}

.role-dropdown-list .dropdown-wrapper {
  width: 100%;
  margin-top: 10px;
}

.role-dropdown-list .dropdown-list {
  max-height: 120px;
}

.popup-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 15px;
}

.update-review-btn {
  max-width: 78.83px !important;
}

.popup-actions button {
  cursor: pointer;
  font-weight: 500;
  line-height: 22px;
  padding: 8px 13px;
  width: 50%;
  font-size: 14px;
  min-height: 42px;
  max-width: max-content;
  gap: 15px;
  background: #000;
  color: var(--white);
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
}

.popupTopClose {
  float: right;
  position: relative;
  top: 0;
  right: 0;
  cursor: pointer;
}

.popupTopClose img {
  width: 15px;
  margin-right: 0;
}

.action-buttons .approve-btn {
  background: #279134;
  border: 1px solid #279134;
  color: #fff;
  padding: 4px 8px;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 5px;
}

.action-buttons .deny-btn {
  background: #c32323;
  border: 1px solid #c32323;
  color: #fff;
  padding: 4px 8px;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 5px;
}

.dataTable-list:after{
  content: none;
}

.loading-list {
  height: 395px;
  overflow: hidden;
}

.deleteLocation {
  width: 78.39px !important;
}

.addLocation {
  width: 67.41px !important;
}

.banner-dropdown-wrapper{
  margin-top: 5px;
  width: 100%;
}

.banner-dropdown-wrapper input[type="checkbox"] {
  font-size: 0;
  width: 18px;
  height: 18px;
  border: 1px solid transparent;
  -o-appearance: none;
  appearance: none;
  position: relative;
  padding: 0 0 0 0;
  margin: 0;
  box-shadow: none;
}

.banner-dropdown-wrapper input[type="checkbox"]::before{
  margin-right: 0;
}

.locationList {
  position: relative;
}

.locationList.loading-list:before{
  max-width: 500px;
  width: 100%;
}

.loading-list:before {
  content: "";
  background: var(--white);
  height: 100%;
  width: 100%;
  top: 0;
  bottom: 0;
  overflow: hidden;
  position: absolute;
  z-index: 1;
}

.loading-list:after {
  position: absolute;
  content: "";
  border: 3px solid #f3f3f3;
  border-top: 3px solid rgb(100 116 139);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  z-index: 2;
  top: calc(50% - 25px);
  left: calc(50% - 25px);
}

.editStatus {
  padding: 2px 5px;
  font-size: 14px;
  border-radius: 6px;
}

.editStatus.Pending {
  background-color: #7777772e;
  /* border: 1px solid var(--cloudburst); */
  color: var(--cloudburst);
}

.editStatus.Completed {
  background-color: #00ab643d;
  /* border: 1px solid #027a48; */
  color: #027a48;
}

.editStatus.Cancelled {
  background-color: #b4231833;
  /* border: 1px solid #b42318; */
  color: #b42318;
}

.editStatus.Shipped {
  background-color: #ff950036;
  /* border: 1px solid #ff9500; */
  color: #ff9500;
}

.editStatus.Processing {
  color: #0c5460;
  background: #d1ecf1;
  /* border: 1px solid #0c5460; */
}

.product-add-dropdown-list {
  display: flex;
  gap: 10px;
  flex-direction: column;
}

.product-add-dropdown-list .dropdown-wrapper input[type="text"]:focus {
  outline: 0;
}

.product-add-dropdown-list .dropdown-wrapper input {
  border: 0;
  font-size: 16px;
}

.product-add-dropdown-list .dropdown-wrapper {
  width: 100%;
}

.product-add-dropdown-list .dropdown-header {
  margin-top: 10px;
  height: 45px;
}

.product-add-dropdown-list .dropdown-list {
  margin-top: 5px;
  max-height: 130px;
  overflow-y: auto;
}

.buttons .add-product-btn {
  /* background-color: #f4f4f4;
  color: #000; */
  padding: 8px 13px;
  line-height: 22px;
  min-height: 42px;
}

.more-product {
  margin-top: 10px;
}

.product-add-dropdown-list.add-border {
  border-bottom: 1px solid #d4d4d4;
  padding-bottom: 15px;
}

.product-add-dropdown-list .dropdown-wrapper .dropdown-search {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 8px;
}

.dropdown-search {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 8px;
}

.dropdown-search:focus-visible, .dropdown-search:focus{
  border: 1px solid #ddd !important;
  outline: none;
}

.add-btn {
  background: #000;
  color: white;
  padding: 10px 18px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
}

.save-btn-group {
  display: flex;
  justify-content: end;
}

.mobile-menu-save .save-btn {
  width: 71.41px;
  height: 39px;
}

.save-btn {
  background: #000;
  color: white;
  padding: 10px 18px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
}

.add-team-user .image-upload-content {
  margin-top: 10px;
  position: relative;
}

.uploading-image {
  position: relative;
}

/* Overlay */
.uploading-image.loading::after {
  content: '';
  position: absolute;
  inset: 0;
  background-color: #fff;
  opacity: 0.4;
  z-index: 1;
  left: 0;
  top: 0;
}

/* Loader */
.uploading-image .ringLoader {
  position: absolute;
  top: 39%;
  z-index: 2;
}

.infinateLoader {
  height: 100px;
  margin-top: 20px;
}

.uploading-image .ringLoader:before, .infinatescroll.ringLoader:before{
  border: 2px solid black;
}

.add-team-user .imageUploadBox {
  cursor: pointer;
  min-height: 60px;
}

.add-team-user .image-upload-content img {
  height: 70px;
  width: 70px;
  object-fit: cover;
}

.add-team-user .uploadPicture {
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}

.add-team-user .save-btn {
  max-width: 61.41px;
}

.role-delete-popup .save-btn {
  max-width: 72.39px;
}

.popup-actions button.cancel-btn {
  border: 1px solid var(--ashyblue);
  background-color: var(--white);
  color: var(--cloudburst);
}

.brand-description {
  max-width: 740px;
  margin: auto;
  padding: 0 20px;
  margin-top: 20px;
  position: relative;
  top: 0;
  height: calc(100vh - 250px);
}

.brand-description textarea {
  height: 100%;
  width: 100%;
  resize: none;
  border: 0;
  outline: 0;
  font-size: 18px;
  font-weight: 400;
  overflow: auto;
  scrollbar-width: none;
}

.brand-description textarea::-webkit-scrollbar {
  display: none;
}

.brand-description textarea {
  scrollbar-width: none;
}

.team-list-name-row {
  display: flex;
  gap: 10px;
  align-items: center;
}

.team-list-name-row img {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.custom-radio {
  appearance: none;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  border: 1px solid var(--darkblue);
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  position: relative;
  margin: 0;
}

.custom-radio:checked {
  border-color: var(--darkblue);
}

.custom-radio:checked::before {
  content: "";
  width: 10px;
  height: 10px;
  background: var(--darkblue);
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-48%, -48%);
}

.refund-reason-dropdown .category-title {
  font-weight: 600;
}

.refund-reason-dropdown .dropdown-item {
  margin-left: 20px;
  font-size: 14px;
}

.add-category-popup .save-btn,
.add-new-customer .save-btn {
  width: 61.41px;
  max-width: 61.41px;
}

.delete-popup .save-btn.delete-btn {
  width: 72.39px;
  max-width: 72.39px;
}

.ringLoader {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin: 0 auto;
  top: 0;
  left: 0;
  right: 0;
  animation: rotate 1s linear infinite;
}

.ringLoader:before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  inset: 0px;
  border-radius: 50%;
  animation: prixClipFix 1s linear infinite;
  top: 0;
}

.ringLoader:before {
  border: 2px solid white;
}

.draft .ringLoader:before {
  border: 2px solid black;
}

.status-badge {
  padding: 5px 10px;
  font-size: 13px;
  border-radius: 6px;
  line-height: 18px;
}

.status-badge.published {
  border: 1px solid var(--greenlableborder);
  color: var(--greenlable);
}

.status-badge.draft {
  border: 1px solid var(--twilightblueborder);
  color: var(--twilightblue);
}

.add-refund .dropdown-item {
  font-size: 14px;
  padding-left: 20px;
}

.swiper-pagination {
  display: none;
}

.error-page {
  min-height: calc(100vh - 67px);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0;
}

.erorBlock {
  text-align: center;
  padding: 10px;
}

.erorBlock span {
  font-weight: 600;
  font-size: 16px;
  color: var(--vibrantblue);
}

.erorBlock .errorTitle {
  font-weight: 600;
  font-size: 18px;
  color: var(--darkblue);
  line-height: 28px;
  margin-bottom: 10px;
  margin-top: 25px;
}

.erorBlock .errorSubtitle {
  font-weight: 400;
  font-size: 14px;
  color: var(--grayishblue);
  line-height: 20px;
  max-width: 340px;
}

.erorButton {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  margin-top: 35px;
}

.erorButton_left svg {
  margin-right: 10px;
  width: 12px;
  height: 12px;
}

.erorButton_left {
  padding: 12px 18px;
  border-radius: 100px;
  background-color: transparent;
  cursor: pointer;
  border: 1px solid var(--ashyblue);
  outline: none;
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  justify-content: center;
  color: var(--cloudburst);
  margin-right: 10px;
}

button.erorButton_right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.erorButton_right {
  padding: 12px 18px;
  border-radius: 100px;
  text-align: center;
  font-weight: 600;
  font-size: 14px;
  color: var(--white);
  background: var(--black);
  border: 1px solid var(--black);
  cursor: pointer;
}

.checkbox-group .checkbox-label {
  align-items: center;
  display: flex;
}

.checkbox-group .checkbox-label input[type="checkbox"]:before {
  margin-right: 5px;
}

.dashboard.productImport {
  margin: 30px
}
.productImport .drag-active {
  opacity: 0.5;
}

.productImport .uploadFileBlock {
  max-width: 800px;
  margin: auto;
  margin-bottom: 50px;
}

.productImport .progressWrap {
  margin: auto;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  left: 50%;
}

.productImport .progressWrap .progress {
  position: relative;
  height: 7px;
  width: 82%;
  border: 1px solid rgb(246, 246, 250);
  border-radius: 15px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.productImport .progressWrap .progress .color {
  position: absolute;
  background-color: #573CFF;
  width: 0px;
  height: 6px;
  border-radius: 15px;
  animation: progress 4s infinite linear;
}

.import-table-wrapper {
  max-width: 800px;
  margin: auto;
  overflow-x: auto;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.import-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 600px;
}

.import-table thead {
  background: #f9fafb;
}

.import-table th {
  text-align: left;
  padding: 14px 18px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  border-bottom: 1px solid #e5e7eb;
  white-space: nowrap;
}

.import-table td {
  padding: 14px 18px;
  font-size: 14px;
  color: #4b5563;
  border-bottom: 1px solid #f1f5f9;
}

.import-table tbody tr:hover {
  background: #f8fafc;
  transition: 0.2s ease;
}

.title-cell {
  font-weight: 500;
  color: #111827;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;
}

.status-badge.done {
  background: #dcfce7;
  color: #166534;
}

.status-badge.fail {
  background: #fee2e2;
  color: #991b1b;
}

.status-badge.pending {
  background: #fef3c7;
  color: #92400e;
}

.empty-state {
  text-align: center;
  padding: 24px;
  color: #9ca3af;
  font-size: 14px;
}

.premium-customer {
  display: flex;
  align-items: center;
  gap: 6px;
}

@media screen and (max-width: 767px) {
  .order-status-dropdown {
    width: 100%;
  }

  .popup-box {
    width: calc(100% - 30px);
    margin: 0px auto;
    padding: 15px;
  }

  input[type="checkbox"] {
    margin-left: 0;
  }

  .dataTable-list .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child {
    min-width: unset;
    padding-top: 20px;
    padding-bottom: 20px;
    justify-content: flex-start;
  }

  .dataTable-list .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child input {
    margin-left: 0;
  }

  .dataTable-list .rdt_TableHeadRow .rdt_TableCol:last-child,
  .dataTable-list .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child {
    justify-content: flex-end;
    position: relative;
    right: 16px;
    padding-right: 0;
    /* min-width: 116px; */

  }

  _::-webkit-full-page-media,
  _:future,
  :root .dataTable-list .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child {
    right: 32px;
    padding-right: 0;
  }

  _::-webkit-full-page-media,
  _:future,
  :root .dataTable-list .rdt_TableHeadRow .rdt_TableCol:last-child {
    right: 32px;
    padding-right: 0;
  }

  _::-webkit-full-page-media,
  _:future,
  :root .subscriber-list .dataTable-list .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child {
    right: 16px !important;
    padding-right: 0;
  }

  _::-webkit-full-page-media,
  _:future,
  :root .subscriber-list .dataTable-list .rdt_TableHeadRow .rdt_TableCol:last-child {
    right: 16px;
    padding-right: 0 !important;
  }

  /* :root .addDropdown li p{
    margin-left: 6px;
  } */

  .dataTable-list>div:first-child {
    overflow: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .dataTable-list>div:first-child::-webkit-scrollbar {
    display: none;
  }

  .dataTable-list>div:first-child {
    scrollbar-width: none;
  }

  .dataTable-list>div:first-child {
    -ms-overflow-style: none;
  }

  .product-add-dropdown-list {
    flex-wrap: wrap;
  }
}


@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes prixClipFix {
  0% {
    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
  }

  25% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
  }

  50% {
    clip-path: polygon(50% 50%,
        0 0,
        100% 0,
        100% 100%,
        100% 100%,
        100% 100%);
  }

  75% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
  }

  100% {
    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAKA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,sGAAsG;AACxG;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,oKAAoK;EACpK,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,+DAAsE;AACxE;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yDAA2D;EAC3D,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,+BAA+B;EAC/B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,wFAAwF;EACxF,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,wFAAwF;EACxF,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;AACb;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,2BAA2B;EAC3B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,+CAA+C;EAC/C,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;;EAGE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,8CAA8C;EAC9C,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,SAAS;EACT,MAAM;AACR;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB;6CAC2C;EAC3C,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,MAAM;EACN,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,sCAAsC;EACtC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,UAAU;EACV,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;gBACc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,OAAO;EACP,MAAM;AACR;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,MAAM;EACN,OAAO;EACP,QAAQ;EACR,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,yCAAyC;EACzC,MAAM;AACR;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,iCAAiC;EACjC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;AACF;AACA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,oCAAoC;EACpC,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,sBAAsB;;EAExB;;EAEA;;;IAGE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;;IAGE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;;IAGE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;;;IAGE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;;KAEG;;EAEH;IACE,cAAc;IACd,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,oDAAoD;EACtD;;EAEA;IACE,gEAAgE;EAClE;;EAEA;IACE;;;;;kBAKc;EAChB;;EAEA;IACE,mEAAmE;EACrE;;EAEA;IACE,gEAAgE;EAClE;AACF","sourcesContent":["@import url(./assets/css/appearance.css);\n@import url(./assets/css/customer.css);\n@import url(./assets/css/header.css);\n@import url(./assets/css/mediapopup.css);\n\n:root {\n  --bg-green: #55883D;\n  --white: #ffffff;\n  --black: #000000;\n  --cloudburst: #344054;\n  --ashyblue: #d0d5dd;\n  --lightgrey: #eaecf0;\n  --grey: #667085;\n  --grayishblue: #475467;\n  --whitesmoke: #f9f9f9;\n  --lightgrey: #eaecf0;\n  --frostedwhite: #fbfbfb;\n  --charcoalblue: #0a2540;\n  --fiord: #425466;\n  --purple: #573cff;\n  --mistygray: #f2f4f7;\n  --ghostwhite: #f9fafb;\n  --grayishblue: #475467;\n  --greenlable: #067647;\n  --greenlableborder: #079455;\n  --twilightblue: #363F72;\n  --twilightblueborder: #3E4784;\n  --boxshadow: 0 1px 3px #0000001a;\n  --eerieblack: #1c1c1c;\n  --darkblue: #101828;\n  --frostedwhite: #fbfbfb;\n  --vibrantblue: #007aff;\n  --tooltipboxshadow: 0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);\n}\n\nul,\nli {\n  list-style-type: none;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody,\nhtml {\n  overflow-x: hidden;\n  position: relative;\n}\n\nbody {\n  background: white;\n}\n\nbody {\n  margin: 0;\n  /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif; */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n@font-face {\n  font-family: 'CyGrotesk-KeyRegular';\n  src: url('./assets/fonts/CyGrotesk-KeyRegular.otf') format('opentype');\n}\n\ninput[type=\"checkbox\"] {\n  cursor: pointer;\n}\n\ninput[type=\"checkbox\"]:checked:before {\n  background-image: url('./assets/images/checkbox-black.svg');\n  border: 1px solid #344054;\n}\n\ninput[type=number] {\n  -moz-appearance: textfield;\n  /* Firefox */\n}\n\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  /* Chrome, Safari, Edge */\n  margin: 0;\n}\n\ninput[type=\"checkbox\"]:before {\n  content: \"\";\n  font-size: 15px;\n  border: 1px solid #d0d5dd;\n  display: block;\n  width: 15px;\n  background: none;\n  height: 15px;\n  margin-right: 7px;\n  border-radius: 4px;\n  min-width: 16px;\n  min-height: 16px;\n  margin-right: 15px;\n  background-size: 60%;\n  background-position: 4px center;\n  background-repeat: no-repeat;\n  accent-color: #e6f2ff;\n}\n\n.pagesTable {\n  background: #fff;\n  border: 1px solid #eaecf0;\n  width: 100%;\n  margin-top: 20px;\n  border-radius: 6px;\n  position: relative;\n}\n\n.dataTable-list .rdt_TableBody .rdt_TableRow {\n  min-height: 62px;\n}\n\n.dataTable-list .rdt_TableHeadRow .rdt_TableCol:first-child,\n.dataTable-list .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child {\n  padding-left: 16px;\n}\n\n.dataTable-list .rdt_TableHeadRow .rdt_TableCol input:first-child {\n  margin-right: 0;\n}\n\n.dataTable-list .rdt_TableHeadRow .rdt_TableCol:last-child,\n.dataTable-list .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child {\n  justify-content: flex-end;\n  padding-right: 16px;\n}\n\n.dataTable-list .rdt_TableHeadRow .rdt_TableCol .__rdt_custom_sort_icon__ {\n  background-image: url(./assets/images/down-arrow.svg);\n  width: 12px;\n  height: 12px;\n  margin-left: 5px;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.dataTable-list .rdt_TableHeadRow .rdt_TableCol .desc.__rdt_custom_sort_icon__ {\n  transform: rotate(180deg);\n}\n\n.dataTable-list {\n  background: #ffffff;\n  border: 1px solid #eaecf0;\n  width: 100%;\n  margin-top: 20px;\n  border-radius: 6px;\n  position: relative;\n}\n\n.dataTable-list input[type=\"checkbox\"]:before {\n  margin-right: 10px;\n}\n\n.dataTable-list .rdt_TableHeadRow .rdt_TableCol {\n  padding: 0;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  justify-content: flex-start;\n}\n\n.dataTable-list .rdt_TableHeadRow div[data-column-id] {\n  font-weight: 500;\n  color: #4e575c;\n  font-size: 14px;\n}\n\n.dataTable-list>div:first-child {\n  padding-bottom: 80px;\n  margin-bottom: -80px;\n}\n\n.dataTable-list>div:last-child {\n  position: relative;\n}\n\n.dataTable-list .user-status a.user-link,\n.user-status {\n  align-items: center;\n  display: flex;\n  gap: 12px;\n}\n\n.dataTable-list .rdt_TableHeadRow .rdt_TableCol:last-child,\n.dataTable-list .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child {\n  justify-content: flex-end;\n  padding-right: 16px;\n}\n\n.dataTable-list .table-action {\n  padding-right: 0;\n}\n\n.table-action img {\n  cursor: pointer;\n}\n\n.table-data-dropdown {\n  padding: 0 !important;\n  background: #fff;\n  border: 1px solid #eaecf0;\n  border-radius: 6px;\n  box-shadow: 0 12px 16px -4px rgba(16, 24, 40, .08), 0 4px 6px -2px rgba(16, 24, 40, .03);\n  min-width: 160px;\n  position: absolute;\n  right: auto;\n  top: 50px;\n  z-index: 99;\n}\n\n.table-data-dropdown.is-open {\n  padding: 0 !important;\n  background: #fff;\n  border: 1px solid #eaecf0;\n  border-radius: 6px;\n  box-shadow: 0 12px 16px -4px rgba(16, 24, 40, .08), 0 4px 6px -2px rgba(16, 24, 40, .03);\n  min-width: 160px;\n  position: absolute;\n  right: auto;\n  top: -115px;\n  z-index: 99;\n}\n\n.table-data-dropdown ul {\n  padding: 0;\n  margin: 0;\n}\n\n.table-data-dropdown li span {\n  align-items: center;\n  color: #111827;\n  display: flex;\n  justify-content: flex-start;\n  padding: 0px 20px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.table-data-dropdown li span:hover {\n  background: #f9f9f9;\n  color: #101828;\n}\n\n.table-data-dropdown li span img {\n  margin-right: 10px;\n}\n\ninput[type=\"checkbox\"] {\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  -o-appearance: none;\n  background: #fff;\n  border: none !important;\n  content: none;\n  cursor: pointer;\n  outline: none;\n  cursor: pointer;\n}\n\n.error-message {\n  font-size: 14px;\n  color: #d92d20;\n  margin-top: 5px;\n  margin-bottom: 0;\n}\n\n.error-border {\n  border-color: #d92d20 !important;\n}\n\n.editor-error {\n  max-width: 740px;\n  margin: auto;\n  padding: 0 20px;\n}\n\n.dataTable-border-list .sc-dYwGCk:last-child,\n.dataTable-border-list .sc-bRKDuR {\n  border-radius: 0 0 6px 6px;\n}\n\n.editTitle a {\n  color: #000;\n}\n\n.category-list .dropdown-list {\n  max-height: 150px;\n}\n\n.dropdown-list {\n  position: absolute;\n  top: 45px;\n  left: 0;\n  width: 100%;\n  background: #fff;\n  border-radius: 6px;\n  border: 1px solid #d0d5dd;\n  padding: 10px 12px;\n  /* box-shadow: 0px 4px 10px rgba(0,0,0,0.15); */\n  z-index: 9;\n  max-height: 260px;\n  overflow-y: auto;\n}\n\n.dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 0;\n  cursor: pointer;\n}\n\n.dropdown-item.customer-list-dropdown {\n  gap: 2px;\n}\n\n.dropdown-item.customer-list-dropdown span:last-child {\n  font-size: 14px;\n}\n\n.dropdown-item input {\n  width: 18px;\n  height: 18px;\n}\n\n.dropdown-wrapper.order-dropdown,\n.dropdown-wrapper.review-dropdown {\n  width: 100%;\n}\n\n.dropdown-wrapper.review-dropdown {\n  margin-top: 10px;\n}\n\n.dropdown-wrapper {\n  width: 240px;\n  position: relative;\n}\n\n.brand-dropdown {\n  margin-top: 10px;\n}\n\n.dropdown-wrapper.send-mail-dropdown,\n.dropdown-wrapper.brand-dropdown,\n.dropdown-wrapper.refund-reason-dropdown {\n  width: 100%;\n}\n\n.send-mail-dropdown .dropdown-list,\n.brand-dropdown .dropdown-list,\n.refund-reason-dropdown .dropdown-list {\n  margin-top: 5px;\n  max-height: 200px;\n}\n\n.category-list,\n.parent-category-list-dropdown {\n  width: 100%;\n}\n\n.dropdown-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  background: #fff;\n  border: 1px solid #d0d5dd;\n  border-radius: 6px;\n  cursor: pointer;\n  user-select: none;\n  /* box-shadow: 0px 2px 4px rgba(0,0,0,0.08); */\n  height: 40px;\n}\n\n.dropdown-header .header-title {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  line-height: 1.1;\n}\n\n.popup-box.add-refund {\n  overflow-y: unset;\n}\n\n.add-refund .dropdown-wrapper {\n  width: 100%;\n}\n\n.add-refund .dropdown-header {\n  justify-content: space-between;\n}\n\n.dropdown-header.customer-list-header>div {\n  width: calc(100% - 30px);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.customer-list-header span {\n  font-size: 14px;\n}\n\n.dropdown-header .title {\n  font-weight: 500;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  line-height: 1.1;\n}\n\n.category-list .dropdown-header,\n.parent-category-list-dropdown {\n  margin-top: 10px;\n}\n\n.category-list .title {\n  color: var(--grey);\n  font-size: 14px;\n}\n\n.category-list .dropdown-item span {\n  font-size: 14px;\n}\n\n.arrow {\n  margin-left: auto;\n  transition: 0.25s;\n  opacity: 0.6;\n  margin-top: -4px;\n}\n\n.arrow.rotate {\n  transform: rotate(180deg);\n  margin-top: 4px;\n}\n\n.product-list .dropdown-wrapper {\n  width: 220px;\n}\n\n.upload-btn {\n  background: #55883b;\n  padding: 8px 14px;\n  color: white;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  display: inline-block;\n}\n\n.image-preview {\n  margin-top: 10px;\n}\n\n.preview-img {\n  width: 80px;\n  height: 80px;\n  object-fit: cover;\n  border-radius: 6px;\n  border: 1px solid #ddd;\n}\n\n\n.image-upload-content {\n  display: flex;\n  gap: 15px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.popupModalTitle {\n  margin-top: 10px;\n  color: #101828;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 20px;\n  margin-bottom: 15px;\n  margin-top: 0;\n  padding: 0;\n}\n\n.popupDesc {\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--grayishblue);\n  line-height: 20px;\n  display: block;\n  margin-bottom: 5px;\n}\n\n.popup-overlay {\n  background-color: rgba(0, 0, 0, .5);\n  opacity: 1;\n  position: fixed;\n  visibility: visible;\n  z-index: 31;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n}\n\n.popup-box {\n  max-height: max-content;\n  overflow-y: auto;\n  background-color: #fff;\n  border: 1px solid #d0d5dd;\n  box-shadow: 0px 8px 8px -4px rgba(16, 24, 40, 0.03),\n    0px 20px 24px -4px rgba(16, 24, 40, 0.08);\n  border-radius: 6px;\n  left: 50%;\n  max-width: 480px;\n  opacity: 1;\n  padding: 25px;\n  position: fixed;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  visibility: visible;\n  width: 100%;\n  z-index: 35;\n  height: 100%;\n  margin: 0 20px 0;\n}\n\n.popup-form .form-group {\n  margin-bottom: 12px;\n}\n\n.popup-form .form-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.popup-form .form-checkbox input {\n  width: 20px;\n}\n\n.role-dropdown-list {\n  margin-top: 12px;\n}\n\n.role-dropdown-list .dropdown-wrapper {\n  width: 100%;\n  margin-top: 10px;\n}\n\n.role-dropdown-list .dropdown-list {\n  max-height: 120px;\n}\n\n.popup-actions {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n  gap: 15px;\n}\n\n.update-review-btn {\n  max-width: 78.83px !important;\n}\n\n.popup-actions button {\n  cursor: pointer;\n  font-weight: 500;\n  line-height: 22px;\n  padding: 8px 13px;\n  width: 50%;\n  font-size: 14px;\n  min-height: 42px;\n  max-width: max-content;\n  gap: 15px;\n  background: #000;\n  color: var(--white);\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.popupTopClose {\n  float: right;\n  position: relative;\n  top: 0;\n  right: 0;\n  cursor: pointer;\n}\n\n.popupTopClose img {\n  width: 15px;\n  margin-right: 0;\n}\n\n.action-buttons .approve-btn {\n  background: #279134;\n  border: 1px solid #279134;\n  color: #fff;\n  padding: 4px 8px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-right: 5px;\n}\n\n.action-buttons .deny-btn {\n  background: #c32323;\n  border: 1px solid #c32323;\n  color: #fff;\n  padding: 4px 8px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-right: 5px;\n}\n\n.dataTable-list:after{\n  content: none;\n}\n\n.loading-list {\n  height: 395px;\n  overflow: hidden;\n}\n\n.deleteLocation {\n  width: 78.39px !important;\n}\n\n.addLocation {\n  width: 67.41px !important;\n}\n\n.banner-dropdown-wrapper{\n  margin-top: 5px;\n  width: 100%;\n}\n\n.banner-dropdown-wrapper input[type=\"checkbox\"] {\n  font-size: 0;\n  width: 18px;\n  height: 18px;\n  border: 1px solid transparent;\n  -o-appearance: none;\n  appearance: none;\n  position: relative;\n  padding: 0 0 0 0;\n  margin: 0;\n  box-shadow: none;\n}\n\n.banner-dropdown-wrapper input[type=\"checkbox\"]::before{\n  margin-right: 0;\n}\n\n.locationList {\n  position: relative;\n}\n\n.locationList.loading-list:before{\n  max-width: 500px;\n  width: 100%;\n}\n\n.loading-list:before {\n  content: \"\";\n  background: var(--white);\n  height: 100%;\n  width: 100%;\n  top: 0;\n  bottom: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: 1;\n}\n\n.loading-list:after {\n  position: absolute;\n  content: \"\";\n  border: 3px solid #f3f3f3;\n  border-top: 3px solid rgb(100 116 139);\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  animation: spin 1s linear infinite;\n  z-index: 2;\n  top: calc(50% - 25px);\n  left: calc(50% - 25px);\n}\n\n.editStatus {\n  padding: 2px 5px;\n  font-size: 14px;\n  border-radius: 6px;\n}\n\n.editStatus.Pending {\n  background-color: #7777772e;\n  /* border: 1px solid var(--cloudburst); */\n  color: var(--cloudburst);\n}\n\n.editStatus.Completed {\n  background-color: #00ab643d;\n  /* border: 1px solid #027a48; */\n  color: #027a48;\n}\n\n.editStatus.Cancelled {\n  background-color: #b4231833;\n  /* border: 1px solid #b42318; */\n  color: #b42318;\n}\n\n.editStatus.Shipped {\n  background-color: #ff950036;\n  /* border: 1px solid #ff9500; */\n  color: #ff9500;\n}\n\n.editStatus.Processing {\n  color: #0c5460;\n  background: #d1ecf1;\n  /* border: 1px solid #0c5460; */\n}\n\n.product-add-dropdown-list {\n  display: flex;\n  gap: 10px;\n  flex-direction: column;\n}\n\n.product-add-dropdown-list .dropdown-wrapper input[type=\"text\"]:focus {\n  outline: 0;\n}\n\n.product-add-dropdown-list .dropdown-wrapper input {\n  border: 0;\n  font-size: 16px;\n}\n\n.product-add-dropdown-list .dropdown-wrapper {\n  width: 100%;\n}\n\n.product-add-dropdown-list .dropdown-header {\n  margin-top: 10px;\n  height: 45px;\n}\n\n.product-add-dropdown-list .dropdown-list {\n  margin-top: 5px;\n  max-height: 130px;\n  overflow-y: auto;\n}\n\n.buttons .add-product-btn {\n  /* background-color: #f4f4f4;\n  color: #000; */\n  padding: 8px 13px;\n  line-height: 22px;\n  min-height: 42px;\n}\n\n.more-product {\n  margin-top: 10px;\n}\n\n.product-add-dropdown-list.add-border {\n  border-bottom: 1px solid #d4d4d4;\n  padding-bottom: 15px;\n}\n\n.product-add-dropdown-list .dropdown-wrapper .dropdown-search {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin-bottom: 8px;\n}\n\n.dropdown-search {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  margin-bottom: 8px;\n}\n\n.dropdown-search:focus-visible, .dropdown-search:focus{\n  border: 1px solid #ddd !important;\n  outline: none;\n}\n\n.add-btn {\n  background: #000;\n  color: white;\n  padding: 10px 18px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.save-btn-group {\n  display: flex;\n  justify-content: end;\n}\n\n.mobile-menu-save .save-btn {\n  width: 71.41px;\n  height: 39px;\n}\n\n.save-btn {\n  background: #000;\n  color: white;\n  padding: 10px 18px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.add-team-user .image-upload-content {\n  margin-top: 10px;\n  position: relative;\n}\n\n.uploading-image {\n  position: relative;\n}\n\n/* Overlay */\n.uploading-image.loading::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background-color: #fff;\n  opacity: 0.4;\n  z-index: 1;\n  left: 0;\n  top: 0;\n}\n\n/* Loader */\n.uploading-image .ringLoader {\n  position: absolute;\n  top: 39%;\n  z-index: 2;\n}\n\n.infinateLoader {\n  height: 100px;\n  margin-top: 20px;\n}\n\n.uploading-image .ringLoader:before, .infinatescroll.ringLoader:before{\n  border: 2px solid black;\n}\n\n.add-team-user .imageUploadBox {\n  cursor: pointer;\n  min-height: 60px;\n}\n\n.add-team-user .image-upload-content img {\n  height: 70px;\n  width: 70px;\n  object-fit: cover;\n}\n\n.add-team-user .uploadPicture {\n  height: 100%;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n}\n\n.add-team-user .save-btn {\n  max-width: 61.41px;\n}\n\n.role-delete-popup .save-btn {\n  max-width: 72.39px;\n}\n\n.popup-actions button.cancel-btn {\n  border: 1px solid var(--ashyblue);\n  background-color: var(--white);\n  color: var(--cloudburst);\n}\n\n.brand-description {\n  max-width: 740px;\n  margin: auto;\n  padding: 0 20px;\n  margin-top: 20px;\n  position: relative;\n  top: 0;\n  height: calc(100vh - 250px);\n}\n\n.brand-description textarea {\n  height: 100%;\n  width: 100%;\n  resize: none;\n  border: 0;\n  outline: 0;\n  font-size: 18px;\n  font-weight: 400;\n  overflow: auto;\n  scrollbar-width: none;\n}\n\n.brand-description textarea::-webkit-scrollbar {\n  display: none;\n}\n\n.brand-description textarea {\n  scrollbar-width: none;\n}\n\n.team-list-name-row {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.team-list-name-row img {\n  height: 40px;\n  width: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.custom-radio {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 18px;\n  height: 18px;\n  border: 1px solid var(--darkblue);\n  border-radius: 50%;\n  cursor: pointer;\n  display: inline-block;\n  position: relative;\n  margin: 0;\n}\n\n.custom-radio:checked {\n  border-color: var(--darkblue);\n}\n\n.custom-radio:checked::before {\n  content: \"\";\n  width: 10px;\n  height: 10px;\n  background: var(--darkblue);\n  border-radius: 50%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-48%, -48%);\n}\n\n.refund-reason-dropdown .category-title {\n  font-weight: 600;\n}\n\n.refund-reason-dropdown .dropdown-item {\n  margin-left: 20px;\n  font-size: 14px;\n}\n\n.add-category-popup .save-btn,\n.add-new-customer .save-btn {\n  width: 61.41px;\n  max-width: 61.41px;\n}\n\n.delete-popup .save-btn.delete-btn {\n  width: 72.39px;\n  max-width: 72.39px;\n}\n\n.ringLoader {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  margin: 0 auto;\n  top: 0;\n  left: 0;\n  right: 0;\n  animation: rotate 1s linear infinite;\n}\n\n.ringLoader:before {\n  content: \"\";\n  box-sizing: border-box;\n  position: absolute;\n  inset: 0px;\n  border-radius: 50%;\n  animation: prixClipFix 1s linear infinite;\n  top: 0;\n}\n\n.ringLoader:before {\n  border: 2px solid white;\n}\n\n.draft .ringLoader:before {\n  border: 2px solid black;\n}\n\n.status-badge {\n  padding: 5px 10px;\n  font-size: 13px;\n  border-radius: 6px;\n  line-height: 18px;\n}\n\n.status-badge.published {\n  border: 1px solid var(--greenlableborder);\n  color: var(--greenlable);\n}\n\n.status-badge.draft {\n  border: 1px solid var(--twilightblueborder);\n  color: var(--twilightblue);\n}\n\n.add-refund .dropdown-item {\n  font-size: 14px;\n  padding-left: 20px;\n}\n\n.swiper-pagination {\n  display: none;\n}\n\n.error-page {\n  min-height: calc(100vh - 67px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 0;\n}\n\n.erorBlock {\n  text-align: center;\n  padding: 10px;\n}\n\n.erorBlock span {\n  font-weight: 600;\n  font-size: 16px;\n  color: var(--vibrantblue);\n}\n\n.erorBlock .errorTitle {\n  font-weight: 600;\n  font-size: 18px;\n  color: var(--darkblue);\n  line-height: 28px;\n  margin-bottom: 10px;\n  margin-top: 25px;\n}\n\n.erorBlock .errorSubtitle {\n  font-weight: 400;\n  font-size: 14px;\n  color: var(--grayishblue);\n  line-height: 20px;\n  max-width: 340px;\n}\n\n.erorButton {\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n  margin-top: 35px;\n}\n\n.erorButton_left svg {\n  margin-right: 10px;\n  width: 12px;\n  height: 12px;\n}\n\n.erorButton_left {\n  padding: 12px 18px;\n  border-radius: 100px;\n  background-color: transparent;\n  cursor: pointer;\n  border: 1px solid var(--ashyblue);\n  outline: none;\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  font-size: 14px;\n  justify-content: center;\n  color: var(--cloudburst);\n  margin-right: 10px;\n}\n\nbutton.erorButton_right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.erorButton_right {\n  padding: 12px 18px;\n  border-radius: 100px;\n  text-align: center;\n  font-weight: 600;\n  font-size: 14px;\n  color: var(--white);\n  background: var(--black);\n  border: 1px solid var(--black);\n  cursor: pointer;\n}\n\n.checkbox-group .checkbox-label {\n  align-items: center;\n  display: flex;\n}\n\n.checkbox-group .checkbox-label input[type=\"checkbox\"]:before {\n  margin-right: 5px;\n}\n\n.dashboard.productImport {\n  margin: 30px\n}\n.productImport .drag-active {\n  opacity: 0.5;\n}\n\n.productImport .uploadFileBlock {\n  max-width: 800px;\n  margin: auto;\n  margin-bottom: 50px;\n}\n\n.productImport .progressWrap {\n  margin: auto;\n  height: 100%;\n  flex-direction: column;\n  justify-content: center;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  left: 50%;\n}\n\n.productImport .progressWrap .progress {\n  position: relative;\n  height: 7px;\n  width: 82%;\n  border: 1px solid rgb(246, 246, 250);\n  border-radius: 15px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.productImport .progressWrap .progress .color {\n  position: absolute;\n  background-color: #573CFF;\n  width: 0px;\n  height: 6px;\n  border-radius: 15px;\n  animation: progress 4s infinite linear;\n}\n\n.import-table-wrapper {\n  max-width: 800px;\n  margin: auto;\n  overflow-x: auto;\n  background: #ffffff;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);\n}\n\n.import-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 600px;\n}\n\n.import-table thead {\n  background: #f9fafb;\n}\n\n.import-table th {\n  text-align: left;\n  padding: 14px 18px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n  border-bottom: 1px solid #e5e7eb;\n  white-space: nowrap;\n}\n\n.import-table td {\n  padding: 14px 18px;\n  font-size: 14px;\n  color: #4b5563;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.import-table tbody tr:hover {\n  background: #f8fafc;\n  transition: 0.2s ease;\n}\n\n.title-cell {\n  font-weight: 500;\n  color: #111827;\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 12px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.status-badge.done {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.status-badge.fail {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.status-badge.pending {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 24px;\n  color: #9ca3af;\n  font-size: 14px;\n}\n\n.premium-customer {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n@media screen and (max-width: 767px) {\n  .order-status-dropdown {\n    width: 100%;\n  }\n\n  .popup-box {\n    width: calc(100% - 30px);\n    margin: 0px auto;\n    padding: 15px;\n  }\n\n  input[type=\"checkbox\"] {\n    margin-left: 0;\n  }\n\n  .dataTable-list .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child {\n    min-width: unset;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    justify-content: flex-start;\n  }\n\n  .dataTable-list .rdt_TableBody .rdt_TableRow .rdt_TableCell:first-child input {\n    margin-left: 0;\n  }\n\n  .dataTable-list .rdt_TableHeadRow .rdt_TableCol:last-child,\n  .dataTable-list .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child {\n    justify-content: flex-end;\n    position: relative;\n    right: 16px;\n    padding-right: 0;\n    /* min-width: 116px; */\n\n  }\n\n  _::-webkit-full-page-media,\n  _:future,\n  :root .dataTable-list .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child {\n    right: 32px;\n    padding-right: 0;\n  }\n\n  _::-webkit-full-page-media,\n  _:future,\n  :root .dataTable-list .rdt_TableHeadRow .rdt_TableCol:last-child {\n    right: 32px;\n    padding-right: 0;\n  }\n\n  _::-webkit-full-page-media,\n  _:future,\n  :root .subscriber-list .dataTable-list .rdt_TableBody .rdt_TableRow .rdt_TableCell:last-child {\n    right: 16px !important;\n    padding-right: 0;\n  }\n\n  _::-webkit-full-page-media,\n  _:future,\n  :root .subscriber-list .dataTable-list .rdt_TableHeadRow .rdt_TableCol:last-child {\n    right: 16px;\n    padding-right: 0 !important;\n  }\n\n  /* :root .addDropdown li p{\n    margin-left: 6px;\n  } */\n\n  .dataTable-list>div:first-child {\n    overflow: auto;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n\n  .dataTable-list>div:first-child::-webkit-scrollbar {\n    display: none;\n  }\n\n  .dataTable-list>div:first-child {\n    scrollbar-width: none;\n  }\n\n  .dataTable-list>div:first-child {\n    -ms-overflow-style: none;\n  }\n\n  .product-add-dropdown-list {\n    flex-wrap: wrap;\n  }\n}\n\n\n@keyframes spin {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes rotate {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes prixClipFix {\n  0% {\n    clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);\n  }\n\n  25% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);\n  }\n\n  50% {\n    clip-path: polygon(50% 50%,\n        0 0,\n        100% 0,\n        100% 100%,\n        100% 100%,\n        100% 100%);\n  }\n\n  75% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);\n  }\n\n  100% {\n    clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
